import { z } from 'zod';

export const getImpactAnswersDtoSchema_RecyclableWaste = z.array(
  z.object({
    id: z.number(),
    userId: z.string(),
    projectId: z.number(),
    sector: z.string(),
    recyclableWasteType: z.string(),
    recyclableWasteQuantity: z.string(),
    isExternal: z.boolean(),
    label: z.string().nullable(),
    source: z.string().nullable(),
    score: z.number().optional(),
    tags: z
      .object({
        values: z
          .array(z.object({ id: z.number(), name: z.string() }))
          .optional(),
      })
      .optional(),
  }),
);

export type QuestionRecyclableWasteDto = {
  id: number;
  userId: string;
  projectId: number;
  sector: string;
  recyclableWasteType: string;
  recyclableWasteQuantity: number | string;
  isExternal: boolean;
  label: string | null;
  source?: string | null;
  score?: number;
  tags?: { values?: Array<{ id: number; name: string }> };
};
